import type { TableComponentSpec } from "../Processing/types";
import type { DuplicationHandler } from "../widgetContract";

export const tableDuplicate: DuplicationHandler<TableComponentSpec> = (spec) => {
  const idMap = new Map<string, string>();
  for (const s of spec.series) {
    const q = crypto.randomUUID();
    idMap.set(s.queryId, q);
    s.queryId = q;
  }
  const cols = spec.table_builder_misc?.columnMetrics;
  if (cols) {
    const remapped: Record<string, string> = {};
    for (const [oldId, metricId] of Object.entries(cols)) {
      remapped[idMap.get(oldId) ?? oldId] = metricId;
    }
    spec.table_builder_misc!.columnMetrics = remapped;
  }
};
